import { render } from "./growCard.vue?vue&type=template&id=520c01a0&scoped=true"
import script from "./growCard.vue?vue&type=script&lang=js"
export * from "./growCard.vue?vue&type=script&lang=js"

import "./growCard.vue?vue&type=style&index=0&id=520c01a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520c01a0"]])

export default __exports__